"use client";

import { useEffect } from "react";

export function HeaderSearchBarScrollObserver({ targetElement }: { targetElement: string }) {
  useEffect(() => {
    const target = document.querySelector(targetElement);
    const header = document.querySelector("#headerSearchBarWrapper");

    if (!target || !header) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          header.classList.add("opacity-0");
        } else {
          header.classList.remove("opacity-0");
        }
      },
      { threshold: 0.3 },
    );

    observer.observe(target);

    return () => observer.disconnect();
  }, []);

  return null;
}
